 async function graphQuery(query,data) {
 console.log(query)
 console.log(data)
  const tokenData = JSON.parse(localStorage['agchimpToken']);

  const settings = {
    url: "https://agchimpapi.azurewebsites.net/api/Shopify/graph",
    method: "POST",
    timeout: 0,
    headers: {
      "Content-Type": "application/json",
      "Authorization": "Bearer " + tokenData.token
    },
    data: JSON.stringify({
      query: query,
      variables:data
    })
    
  };
console.log(data);
  // jQuery AJAX returns a Promise-compatible object
  return $.ajax(settings);
}

function formatDateMMDDYYYY(isoString) {
  if (!isoString) return "";

  const date = new Date(isoString);

  const month = String(date.getUTCMonth() + 1).padStart(2, "0");
  const day = String(date.getUTCDate()).padStart(2, "0");
  const year = date.getUTCFullYear();

  return `${month}/${day}/${year}`;
}